var numberFormatter = function numberFormatter(_ref) {
  var _ref$style = _ref.style,
    style = _ref$style === void 0 ? 'decimal' : _ref$style,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? 0 : _ref$value,
    _ref$currency = _ref.currency,
    currency = _ref$currency === void 0 ? 'BRL' : _ref$currency,
    _ref$decimals = _ref.decimals,
    decimals = _ref$decimals === void 0 ? 2 : _ref$decimals,
    _ref$currencyDisplay = _ref.currencyDisplay,
    currencyDisplay = _ref$currencyDisplay === void 0 ? 'symbol' : _ref$currencyDisplay;
  return Intl.NumberFormat('pt-BR', {
    style: style,
    currency: currency,
    currencyDisplay: currencyDisplay,
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  }).format(value);
};
module.exports = numberFormatter;